import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import { adminMainUrl } from '../../../../../../../Config';
// import { adminMainUrl } from '../../../../../../Config';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const AirImportTracking = ({ accessedModules, accessedPermission }) => {
    const navigate = useNavigate()
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,
    } = useSelector(state => state?.MasterReducer);

    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    // const columns = [
    //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    //     { title: "Date", dataIndex: "date", key: "date" },
    //     { title: "Name", dataIndex: "name", key: "name" },
    //     { title: "Email", dataIndex: "email", key: "email" },
    //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    //     { title: "Origin", dataIndex: "origin", key: "origin" },
    //     { title: "Destination", dataIndex: "destination", key: "destination" },
    //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    //     { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "OL", dataIndex: "Joborderno", key: "Joborderno" },
        { title: "FL", dataIndex: "Trackingno", key: "Trackingno" },
        { title: "E Docket", dataIndex: "Date", key: "Date" },
        { title: "Date", dataIndex: "Transportmode", key: "Transportmode" },
        { title: "Job No", dataIndex: "Transporttype", key: "Transporttype" },
        { title: "Tracking No", dataIndex: "Shipper", key: "Shipper" },
        { title: "Importer", dataIndex: "Consignee", key: "Consignee" },
        { title: "BE Type", dataIndex: "Originagent", key: "Originagent" },
        { title: "Port of Shipment", dataIndex: "Destinationagent", key: "Destinationagent" },
        { title: "Custom House", dataIndex: "Masternotify", key: "Masternotify" },
        { title: "Status", dataIndex: "Loadingport", key: "Loadingport" },
        { title: "Provisional Assessment", dataIndex: "Dischargeport", key: "Dischargeport" },
        { title: "Duty Under Protest", dataIndex: "Shipmentno", key: "Shipmentno" },
        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
        key: "1", 
        SNo: "1", 
        
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>
                </div>
            </div>
        )
    },
    {
        key: "2", 
        SNo: "2", 
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-danger   `}>Inactive</span>
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    },

    {
        key: "3", 
        SNo: "3", 
        
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>


            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    },]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                          Air Import Shipment Tracking<span className="count-title"></span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">
                    <div className="card-body">
  <div className="row">
    <div className="col-md-12 text-center">
      {/* Pre-Alert Section */}
      <div className="row"  style={{ paddingLeft: "100px" }}>
        <div className="col-md-6 d-flex flex-column align-items-end">
      <div className="workflow-section">
        <a className="btn btn-primary text-xs w-100" onClick={() => { navigate("/flexichain/pre-alert") }}>
          Pre-Alert
        </a>
        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
       
        <div className="row pb-2 pt-1">
       
          <div className="col-md-6 d-flex flex-column align-items-end">
          <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
            <a className="btn btn-primary text-xs"  style={{ whiteSpace: "nowrap" }} onClick={() => { navigate("/flexichain/air-import/tracking/preparecan") }}>
              Prepare CAN
            </a>
            <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
            <a className="btn btn-primary text-xs" onClick={() => { navigate("/flexichain/air-import/tracking/issue-do") }}>
              Issue DO
            </a>
            <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
          </div>
         
          <div className="col-md-6 d-flex flex-column align-items-center">
            
          <div className="col-md-12 d-flex flex-column align-items-start">

          <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
          </div>
            <a className="btn btn-primary text-xs" onClick={() => { navigate("/flexichain/air-import/tracking/flight-arrival") }}>
              Flight Arrival
            </a>
            <div className="arrow mb-0 pb-0 text-center "><i className="fa fa-arrow-down-long mb-0 pb-0 "></i></div>
            <div className="arrow mb-0 pb-0 text-center "><i className="fa fa-arrow-down-long mb-0 pb-0 "></i></div>
            <div className="arrow mb-0 pb-0 text-center "><i className="fa fa-arrow-down-long mb-0 pb-0 "></i></div>
            
          </div>
        </div>
      </div>

        </div>
        <div className="col-md-6 d-flex flex-column align-items-start">

      <div className="workflow-section">

        <a className="btn btn-primary text-xs" onClick={() => { navigate("/flexichain/air-import/tracking/cgm") }}>
          CGM Filing
        </a>
        <div className="arrow mb-0 pb-0 text-center "><i className="fa fa-arrow-down-long mb-0 pb-0 "></i></div>

        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
        <div className="arrow"><i className="fa fa-arrow-down-long"></i></div>
      </div>
        </div>
          
      </div>

    

      {/* Delivery Section */}
      <div className="workflow-section mt-0 pt-0 d-flex flex-column align-items-center">
             <a className="btn btn-primary text-xs w-50 "  style={{ letterSpacing: "2px" }} onClick={() => { navigate("/flexichain/air-import/tracking/Delivery") }}>
          Delivery
        </a>
       
        <a className="btn btn-primary text-xs w-50 mt-2" style={{ letterSpacing: "2px" }} onClick={() => { navigate("/flexichain/air-import/tracking/user-milestone-air") }}>
          User Milestone
        </a>
      </div>
    </div>
  </div>
</div>

                    </div>
                </div>
            </div>
            {/* <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
            <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />
            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default AirImportTracking